__turbopack_context__.v({
  "table-cell-content": "W36xnq_table-cell-content",
});
